/* unplugin-vue-components disabled */import script from "./SelectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectColor.vue?vue&type=script&setup=true&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=43038dcf&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43038dcf"]])

export default __exports__